
import { combineReducers } from 'redux';
import network, { NetworkState } from "./reducers/slices/networkSlice"
// import authReducer from "./reducers/slices/authSlice";

interface RootState {
    network: NetworkState;
//    auth: AuthState;

}

const rootReducer = combineReducers({
    network: network
//    auth: authReducer,

});

export default rootReducer;
export type { RootState };
